<template>
  <div class="flex flex-shrink-0 w-full bg-[#242929]">
    <div class="text-white/40 px-2.5 py-[7px] cursor-default text-[13px] whitespace-nowrap overflow-hidden overflow-ellipsis">
      Boards
    </div>
  </div>
</template>
